import { jsx as _jsx } from "react/jsx-runtime";
import { useController, useFormContext } from 'react-hook-form';
import { ToolboxSettingField } from '@app/pages/profiles/profile-details/profile-ide-provisioner/settings/toolbox-settings/form/toolbox-setting-field';
import { assignTestId } from '@common/infra/tests/assign-test-id';
const DEFAULT_ALLOW_UNMANAGED_IDE_INSTALLATION_TOOLBOX_SETTING = {
    value: false
};
export function AllowUnmanagedIdeInstallationSettingField() {
    var _a;
    const { control } = useFormContext();
    const { field: { value: allowUnmanagedIdeInstallation, onChange: onAllowUnmanagedIdeInstallationChange } } = useController({
        control,
        name: 'content.allowUnmanagedIdeInstallation'
    });
    return (_jsx(ToolboxSettingField, { label: "Allow unmanaged IDE installation", value: (_a = allowUnmanagedIdeInstallation === null || allowUnmanagedIdeInstallation === void 0 ? void 0 : allowUnmanagedIdeInstallation.value) !== null && _a !== void 0 ? _a : DEFAULT_ALLOW_UNMANAGED_IDE_INSTALLATION_TOOLBOX_SETTING.value, onChange: newValue => {
            onAllowUnmanagedIdeInstallationChange({
                value: newValue
            });
        }, ...assignTestId('allow-unmanaged-ide-installation-toolbox-setting-field') }));
}
